/* RESPONSIBLE TEAM: team-standalone */
// eslint-disable-next-line no-restricted-imports
import { getFinStandaloneService } from 'embercom/lib/container-lookup';
import type Workflow from 'embercom/models/operator/visual-builder/workflow';
import EditorConfig, {
  type PathConfigGenerationParams,
} from 'embercom/objects/visual-builder/configuration/editor';
import { StandaloneMessengerConversationStartedPathConfig } from 'embercom/objects/visual-builder/configuration/path';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

export default class StandaloneMessengerConversationStartedBotConfig extends EditorConfig {
  private finStandaloneService: FinStandaloneService;

  constructor({
    areStepPaywallsActive,
    workflow,
  }: {
    areStepPaywallsActive: boolean;
    workflow?: Workflow;
  }) {
    super({ areStepPaywallsActive, workflow });
    this.finStandaloneService = getFinStandaloneService();
  }

  generatePathConfig({ path, editorState }: PathConfigGenerationParams) {
    return new StandaloneMessengerConversationStartedPathConfig({
      path,
      editorState,
      supportsLocalAttributes: this.supportsLocalAttributes,
      isZendeskConfigured: this.isZendeskConfigured,
      isSalesforceConfigured: this.isSalesforceConfigured,
    });
  }

  get isZendeskConfigured(): boolean {
    return this.finStandaloneService.zendeskConfig?.isConnected || false;
  }

  get isSalesforceConfigured(): boolean {
    // eslint-disable-next-line @intercom/intercom/no-direct-salesforce-platform-access -- This still needs a refactor
    return this.finStandaloneService.salesforcePlatform.salesforceConfig?.isConnected || false;
  }

  get supportsConversationChannelTargeting(): boolean {
    return false;
  }

  get supportsSideSheet(): boolean {
    return false;
  }
}
